/** Application chrome is scoped to workspaces; public marketing routes keep their design. */
export function isWorkspacePath(pathname: string): boolean {
  return /^\/(admin|licensed)(\/|$)/.test(pathname) || pathname === "/sign-in";
}
